import MetaParser from './MetaParser';

class VisaRequestParser extends MetaParser implements VisaRequest {
  country_name = '';
  service_fee = '';
  taxes_and_gateway_charges = '';
  total_amount = '';
  name = '';
  show_faqs = false;
  logo_url = '';
  logo_image_url = '';
  note = '';
  bundle = '';
  required_documents: string[] = [];
  document_list: string[] = [];
  consent_message = '';
  status = '';
  code = '';
  visa_application_token = '';
  visitor_id = '';
  visa_request_id = '';
  expire_at = '';
  admin_email = '';
  paid_at = '';

  constructor(request: VisaRequest) {
    super();
    this.util.assign(this, request);
  }

  get check_for_redirection() {
    return this.payment_required;
  }

  get application_code() {
    return this.code ? 'Application number: ' + this.code : '';
  }

  get completed() {
    const keys = [
      'completed',
      'submitted',
      'background_process_completed',
      'submitting',
    ];
    return keys.includes(this.status);
  }

  get expired() {
    const keys = ['expired', 'purged'];
    return keys.includes(this.status);
  }

  get show_timer() {
    return !this.completed && !this.expired;
  }

  get paid() {
    return this.status === 'paid';
  }

  get draft() {
    return this.status === 'draft';
  }

  get required_payment() {
    return !this.paid && this.payment_required;
  }

  get fila_name() {
    const token = this.visa_application_token || this.code;
    return `DuVerify ${token.toUpperCase()}.pdf`;
  }

  get is_invalid() {
    return this.status === 'expired' || this.status === 'purged';
  }
}

export default VisaRequestParser;
